// extracted by mini-css-extract-plugin
module.exports = {"terms":"_10Zkuc1","terms_block":"_1ZbNyrg","signatory_title":"dlBREsk","signatory_block":"_1pLsDAl","signatory_button":"_2LwJJcH"};